import { waitFor } from './waitFor';

const LOCAL_STORAGE_SYNC_TIME_MS = 100;

export const waitForLocalStorageSync = () =>
  waitFor(LOCAL_STORAGE_SYNC_TIME_MS);
